import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

// TODO: Tauri-specific update logic backed up in app.component.tauri-backup.ts
// Remove this file and restore backup when Tauri desktop support is needed

@Component({
  selector: 'stx-desktop-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  styles: `
    :host {
      display: block;
      height: 100vh;
      overflow: hidden;
    }
  `,
  template: `<router-outlet />`,
})
export class AppComponent {
  title = 'control-hub-desktop';
}
